import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { fetchCustomerRequestsCount } from "../api/myBookingsApi";
import {
	MY_BOOKINGS_QUERY_KEYS,
	MY_BOOKINGS_NOTIFICATION_QUERY_ROOT,
} from "../constants/queryKeys";

// Compteur de demandes non lues (badge « mes demandes »). Se déclenche dès que l'email
// est présent ; l'email faisant partie de la clé, le badge se vide de lui-même au logout
// (email remis à null → query désactivée).
export const useMyBookingsCustomerRequestsCount = () => {
	const email = useSelector(state => state.email);
	const brand = useSelector(state => state.brand.code);
	const shop = useSelector(state => state.shop);

	const { data } = useQuery({
		queryKey: MY_BOOKINGS_QUERY_KEYS.notification(brand, shop, email),
		queryFn: () => fetchCustomerRequestsCount({ brand, shop, email }),
		enabled: Boolean(email),
		select: response => response?.totalNotRead || 0,
	});

	return data || 0;
};

// À appeler par les producteurs (login, recherche booking, création de demande…) pour
// forcer un rafraîchissement du compteur.
export const useInvalidateMyBookingsNotification = () => {
	const queryClient = useQueryClient();
	return () => queryClient.invalidateQueries({ queryKey: [MY_BOOKINGS_NOTIFICATION_QUERY_ROOT] });
};
